export const officeDocumentElementI18nEn = {
    odocTitleOptional: 'Title (optional)',
    odocDocumentTitlePlaceholder: 'Document title',
    odocDocumentUrlLabel: 'Document URL',
    odocUrlPlaceholder: 'https://… (PDF or Office file)',
    odocUploadFile: 'Upload file',
    odocUploading: 'Uploading…',
    odocNoDocumentUrl: 'No document URL configured',
    odocLoadingDocument: 'Loading document…',
    odocCouldNotDownloadPreview: 'Could not download this file for preview.',
    odocDownloadingForPreview: 'Downloading for preview…',
    odocLegacyIntro:
        'In-browser preview supports .docx, .xlsx, .pptx, and .pdf.',
    odocLegacyOldDoc:
        'Older .doc files cannot be shown here. Download the file to open it locally.',
    odocLegacyOldPpt:
        'Older .ppt files cannot be shown here. Download the file to open it locally.',
    odocDownload: 'Download',
    odocFallbackFileName: 'document',
    odocImageAltFallback: 'Document',
    odocLoadingPresentation: 'Loading presentation…',
    odocPresentationPreviewFailed: 'Could not load presentation preview.',
    odocPreviewFailedShort: 'Preview failed for this document.',
    odocPreviewUnavailableWithExt:
        'Preview is not available for this file type{ext}. Download to open it.',
    odocPreviewUnavailableUnknown:
        'Preview is not available for this file type. Download to open it.',
} as const satisfies Record<string, string>;

export const officeDocumentElementI18nVi = {
    odocTitleOptional: 'Tiêu đề (tuỳ chọn)',
    odocDocumentTitlePlaceholder: 'Tiêu đề tài liệu',
    odocDocumentUrlLabel: 'URL tài liệu',
    odocUrlPlaceholder: 'https://… (PDF hoặc Office)',
    odocUploadFile: 'Tải tệp lên',
    odocUploading: 'Đang tải lên…',
    odocNoDocumentUrl: 'Chưa cấu hình URL tài liệu',
    odocLoadingDocument: 'Đang tải tài liệu…',
    odocCouldNotDownloadPreview: 'Không tải được tệp để xem trước.',
    odocDownloadingForPreview: 'Đang tải để xem trước…',
    odocLegacyIntro:
        'Xem trong trình duyệt hỗ trợ .docx, .xlsx, .pptx và .pdf.',
    odocLegacyOldDoc:
        'Tệp .doc cũ không hiển thị được tại đây. Hãy tải về để mở trên máy.',
    odocLegacyOldPpt:
        'Tệp .ppt cũ không hiển thị được tại đây. Hãy tải về để mở trên máy.',
    odocDownload: 'Tải về',
    odocFallbackFileName: 'tài liệu',
    odocImageAltFallback: 'Tài liệu',
    odocLoadingPresentation: 'Đang tải bản trình chiếu…',
    odocPresentationPreviewFailed: 'Không tải được xem trước bản trình chiếu.',
    odocPreviewFailedShort: 'Xem trước tài liệu thất bại.',
    odocPreviewUnavailableWithExt:
        'Không có xem trước cho loại tệp{ext}. Hãy tải về để mở.',
    odocPreviewUnavailableUnknown:
        'Không có xem trước cho loại tệp này. Hãy tải về để mở.',
} as const satisfies Record<string, string>;

export type OfficeDocumentElementI18nKey = keyof typeof officeDocumentElementI18nEn;

export const defaultOfficeDocumentBlockI18n = {
    en: { ...officeDocumentElementI18nEn },
    vi: { ...officeDocumentElementI18nVi },
};
